export const PARSER_SELECTED_LEVEL_KEY = 'mhe:selectionTag';

export interface ParserOptions {
  defaultLevel?: string
  [PARSER_SELECTED_LEVEL_KEY]?: string
}
